import { useContext } from 'react';
import useCookie from 'app/hooks/useCookie';
import { WSUserContext } from 'app/contexts/UserContext/UserContext';

interface RecentlyLinksI {
  title: string;
  link: string;
}

export default function useRecentlyLinks() {
  const user = useContext(WSUserContext);
  const [value, update] = useCookie(
    `recentlyViewedLinks${user.userData?.username}`,
    JSON.stringify([]),
  );

  const recentlyLinks: RecentlyLinksI[] = JSON.parse(value);

  const updateRecentlyLinks = (title: string, link: string) => {
    if (user.isAuthenticated()) {
      if (recentlyLinks.length && recentlyLinks[0].link === link) return;
      if (recentlyLinks.length === 8) recentlyLinks.pop();
      recentlyLinks.unshift({ title, link });
      update(JSON.stringify(recentlyLinks));
    }
  };

  return { recentlyLinks, updateRecentlyLinks };
}
